/**
 * @generated SignedSource<<53fad74c2d85a31117b467caf54410f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllWidgets_widget$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"AllWidgetsContent_widget">;
  readonly " $fragmentType": "AllWidgets_widget";
};
export type AllWidgets_widget$key = {
  readonly " $data"?: AllWidgets_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllWidgets_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllWidgets_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AllWidgetsContent_widget"
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};

(node as any).hash = "6c6db568311d2c8fedd3d0cd1e00041e";

export default node;
